export default (value) => {
  let res = 'Yes';
  if (
    typeof value === 'undefined' ||
    value === 'false' ||
    value === 'off' ||
    value === 'no' ||
    value === 'No' ||
    value === '' ||
    value === '0' ||
    value === 0 ||
    value === null ||
    value === false
  ) {
    res = 'No'
  }
  return res;
}
